module.exports = __webpack_public_path__ + "img/ic-edit.dce80e5b.svg";